import React, { useEffect, useState } from "react";
import ErrorModal from "./organisms/ErrorModal";
import { Button, Carousel } from "antd";
import Header from "./headerPhase2";
import { Helmet } from "react-helmet";
import { Skeleton } from "antd";
import homeIcon from "./../assets/img/home-icon.svg";
import axios from "axios";

const API_URL = process.env.REACT_APP_DEVELOPMENT_API_URL;

const PaymentConfirmation = () => {
  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const [amountComparison, setAmountComparison] = useState(null);
  const [loading, setLoading] = useState(true);

  const queryString = window.location.search;
  const searchParams = new URLSearchParams(queryString);
  const paymentguid = searchParams.get("paymentguid");
  const amountDue = searchParams.get("amountDue");
  const [doxyUrl, setDoxyUrl] = useState(null)
  const [response, setResponse] = useState(null)

  useEffect(() => {
    const getPaymentStatus = async () => {
      if (paymentguid == null || amountDue == null) {
        return;
      }

      setLoading(true);

      try {
        const apiUrl = `${API_URL}PatientPayments/GetPaymentStatusInformation?uuId=${paymentguid}`;
        const response = await axios.get(apiUrl);
        setResponse(response.data)
        const paymentAmount =
          response.data.paymentStatusResponse.paymentStatusInformation.amount;

        if (parseFloat(paymentAmount) == parseFloat(amountDue)) {
          setAmountComparison(true);
        } else if (parseFloat(paymentAmount) != parseFloat(amountDue)) {
          setAmountComparison(false);
        }
        setDoxyUrl(response.data.paymentStatusResponse.paymentStatusInformation.doxyUrl)
      } catch (err) {
        setApiErrorMessage(true);
      } finally {
        setLoading(false);
      }
    };

    getPaymentStatus();
  }, []);

  const renderCarousel = () => (
    <Carousel>
      {[
        "clinic-pic-one",
        "clinic-pic-two",
        "clinic-pic-three",
        "clinic-pic-four",
      ].map((pic, index) => (
        <div key={index}>
          <div className={pic}></div>
        </div>
      ))}
    </Carousel>
  );

  return (
    <>
      <ErrorModal
        visible={apiErrorMessage}
        onClose={() => setApiErrorMessage(false)}
      />
      <Header />
      <Helmet>
        <title>CORA Health | Amount Due</title>
      </Helmet>
      <div className="checkin-page-carousel d-flex justify-content-between row">
        <div className="col-lg-7 submit-container">
          <div className="appointment-booked-page ap-details-card text-center amount-due-card bg-white m-4 w-75">
            {loading ? (
              <div className="w-75">
                <Skeleton active style={{ width: "100%" }} />
              </div>
            ) : (
              <>
                <h4>
                  {amountComparison == true
                    ? "Thank you. We look forward to treating you."
                    : "Thank you."}
                </h4>
                <div className="text-lead mb-2">
                  <h5>Your Payment of ${amountDue} has been received.</h5>
                  <h6 className={`${doxyUrl && 'mb-4'}`}>
                    {amountComparison == true
                      ? "You are checked in for your appointment"
                      : response.saveRecordsResponseModel.isTelehealth ? "" : "Please proceed to the front desk"}
                  </h6>
                  {doxyUrl && (
                    <a
                      className="verify-btn p-3"
                      href={doxyUrl}
                      target="_blank"
                      style={{ color: 'black', textDecoration: 'none' }}
                    >
                      Click here to start your telehealth appointment
                    </a>
                  )}
                </div>
                <div className="btns">
                  <Button
                    className="go-home-btn"
                    onClick={() => window.location.replace("https://coraphysicaltherapy.com")}
                    size="large"
                  >
                    <img alt="" src={homeIcon} />
                    Home
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="col-lg-5 p-0 carousel-column">{renderCarousel()}</div>
      </div>
    </>
  );
};

export default PaymentConfirmation;
